
 <div class="content-wrapper pt-2">
  <!-- Main content -->
  <section class="content">
   
    <!-- Default box -->
    <div class="card card-info"  [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header">Supplier</div> 
      <form  [formGroup] ="addSupplierForm"  autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal">
      <fieldset>
      <div class="card-body">

        <div class="form-group row">
          <input  name="id" readonly formControlName="id"  id="id"  class="form-control"    type="hidden">
          </div>

        <div class="form-group row">
          <label for="supId" class="col-md-2 col-form-label col-form-label-sm">ID</label>  
          <div class="col-md-8">
          <div class="input-group">
            <div class="input-group-prepend">
          <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
          </div>
          <input [ngClass]="{'dark-input-field' : isDark }"   readonly formControlName="supId" placeholder="Supplier Id"   class="form-control field-bg-color" [class.is-invalid]="formErrors.supId" (blur)="logValidationErrors()"   type="text">
            </div>
            <span class="text-danger" *ngIf="formErrors.supId"><small>{{formErrors.supId}}</small> </span>   
          </div>
          </div>

          <div class="form-group row">
            <label for="supName" class="col-md-2 col-form-label">Name</label>  
            <div class="col-md-8">
            <div class="input-group">
              <div class="input-group-prepend">
            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
            </div>
            <input [ngClass]="{'dark-input-field' : isDark }"   formControlName="supName" placeholder="Supplier Name" class="form-control" [class.is-invalid]="formErrors.supName" (blur)="logValidationErrors()" type="text">   
              </div>
              <span class="text-danger" *ngIf="formErrors.supName"><small>{{formErrors.supName}}</small> </span>   
            </div>
            </div>
            

            <div class="form-group row">
              <label for="address" class="col-md-2 col-form-label ">Address</label>  
              <div class="col-md-8">
              <div class="input-group">
                <div class="input-group-prepend">
              <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-home"></i></span>
              </div>
              <textarea  [ngClass]="{'dark-input-field' : isDark }"  formControlName="address" placeholder="Address" class="form-control" [class.is-invalid]="formErrors.address" (blur)="logValidationErrors()"  rows="3"></textarea>
                </div>
                <span class="text-danger" *ngIf="formErrors.address"><small>{{formErrors.address}}</small> </span>   
              </div>
              </div>

              <div class="form-group row">
                <label for="vatNo" class="col-md-2 col-form-label ">VAT No</label>  
                <div class="col-md-8">
                <div class="input-group">
                  <div class="input-group-prepend">
                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="far fa-list-alt"></i></span>
                </div>
                <input [ngClass]="{'dark-input-field' : isDark }" formControlName="vatNo" placeholder="VAT No"  class="form-control"  type="text">
              </div>
                </div>
                </div>

                <div class="form-group row">
                  <label for="svatNo" class="col-md-2 col-form-label ">SVAT No</label>  
                  <div class="col-md-8">
                  <div class="input-group">
                    <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-vcard"></i></span>
                  </div>
                  <input  [ngClass]="{'dark-input-field' : isDark }" formControlName="svatNo" placeholder="SVAT Reg.No" class="form-control"  type="text">
                </div>
                </div>
                  </div>
  
                  <div class="form-group row">
                    <label for="phone" class="col-md-2 col-form-label ">Phone</label>  
                    <div class="col-md-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-phone"></i></span>
                    </div>
                    <input  [ngClass]="{'dark-input-field' : isDark }" formControlName="phone" placeholder="Phone Number" class="form-control" [class.is-invalid]="formErrors.phone" (blur)="logValidationErrors()"  type="text">
                  </div>
                  <span class="text-danger" *ngIf="formErrors.phone"><small>{{formErrors.phone}}</small> </span>   
                    </div>
                    </div>

              
                      <div class="form-group row">
                        <label for="email" class="col-md-2 col-form-label ">Email</label>  
                        <div class="col-md-8">
                        <div class="input-group">
                          <div class="input-group-prepend">
                        <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-envelope"></i></span>
                        </div>
                        <input  [ngClass]="{'dark-input-field' : isDark }" formControlName="email" placeholder="Email"  class="form-control" [class.is-invalid]="formErrors.email" (blur)="logValidationErrors()"  type="text">
                      </div>
                      <span class="text-danger" *ngIf="formErrors.email"><small>{{formErrors.email}}</small> </span>   
                        </div>
                        </div>

                        <div class="form-group row">
                          <label for="paymentDetails" class="col-md-2 col-form-label ">Payment Details</label>  
                          <div class="col-md-8">
                          <div class="input-group">
                            <div class="input-group-prepend">
                          <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-home"></i></span>
                          </div>
                          <textarea  [ngClass]="{'dark-input-field' : isDark }"  formControlName="paymentDetails" placeholder="Payment Details" class="form-control" rows="4"></textarea>
                            </div>  
                          </div>
                          </div>
    

                          <div class="form-group row">
                            <div class="col-md-2"></div>
                            <div class="col-md-8">
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox"  formControlName="status">
                                <label class="form-check-label" for="status">
                                  Deactivated
                                </label>
                              </div>
                            </div>
                          </div>  

      </div>                                
      <!-- /.card-body -->
      <div class="card-footer">
        <button type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>

        <button *ngIf="crud_access.create"  type="submit" [disabled]="isSaveBtnDisabled" class="btn btn-info ml-2">
          <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Save
        </button>

        <button class="btn btn-primary ml-2" routerLink="../supplier-list"><i class="fa fa-table p-1"></i>Supplier List</button>
        <button  type="button"  *ngIf ="isShowAttachBtn" class="btn btn-primary ml-2" (click)="attachFileButtonClick()"><i class="fa fa-plus p-1"></i>Attach Files</button>        
      </div>
      <!-- /.card-footer-->
    </fieldset>
      </form>
    </div>
  </section>
  </div>


    <!-- Form Values : {{ addSupplierForm.value | json }} -->
  


    
  
